function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#default_svg__clip0_75_4977)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.921 0H.087v1.142H.53V11.63c0 .628.26 1.231.725 1.675A2.529 2.529 0 003.003 14c.656 0 1.285-.25 1.749-.694a2.321 2.321 0 00.724-1.676V1.142h.445V0zM4.752 11.63c-.011.437-.2.852-.526 1.156a1.787 1.787 0 01-1.219.476c-.455 0-.893-.17-1.219-.474a1.642 1.642 0 01-.528-1.155v-.609h1.2v-.67h-1.2V9.171h1.2v-.687h-1.2V7.304h1.2v-.688h-1.2v-1.18h1.2v-.672h-1.2v-1.18h1.2v-.672h-1.2V1.133h3.492v10.498zM8.078 0v1.142h.445V11.63c0 .628.26 1.231.724 1.675a2.529 2.529 0 001.749.695c.656 0 1.285-.25 1.749-.694a2.321 2.321 0 00.724-1.676V1.142h.444V0H8.078zm4.665 6.12H9.25v-.68h1.2v-.67h-1.2V3.588h1.2v-.67h-1.2v-1.78h3.492V6.12z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "default_svg__clip0_75_4977"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v13.999H0z"
})));

var SvgDefault = function SvgDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgDefault;